import { Profile360Apis } from "./api";
import { profile360ApiHelper } from "./helper";
export default ({ addCase }) => {
  Object.keys(Profile360Apis).forEach((key) => {
    ["pending", "fulfilled", "rejected"].forEach((state) =>
      addCase(Profile360Apis[key][state], profile360ApiHelper[key])
    );
  });
};
